// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: payments.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.payments";

export enum PaymentProvider {
  PAYMENT_PROVIDER_UNKNOWN = 0,
  HDFC = 1,
  UNRECOGNIZED = -1,
}

export function paymentProviderFromJSON(object: any): PaymentProvider {
  switch (object) {
    case 0:
    case "PAYMENT_PROVIDER_UNKNOWN":
      return PaymentProvider.PAYMENT_PROVIDER_UNKNOWN;
    case 1:
    case "HDFC":
      return PaymentProvider.HDFC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PaymentProvider.UNRECOGNIZED;
  }
}

export function paymentProviderToJSON(object: PaymentProvider): string {
  switch (object) {
    case PaymentProvider.PAYMENT_PROVIDER_UNKNOWN:
      return "PAYMENT_PROVIDER_UNKNOWN";
    case PaymentProvider.HDFC:
      return "HDFC";
    case PaymentProvider.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PaymentPurpose {
  PAYMENT_PURPOSE_UNKNOWN = 0,
  ADD_BANK_ACCOUNT = 1,
  DEPOSIT = 2,
  REFUND = 3,
  UNRECOGNIZED = -1,
}

export function paymentPurposeFromJSON(object: any): PaymentPurpose {
  switch (object) {
    case 0:
    case "PAYMENT_PURPOSE_UNKNOWN":
      return PaymentPurpose.PAYMENT_PURPOSE_UNKNOWN;
    case 1:
    case "ADD_BANK_ACCOUNT":
      return PaymentPurpose.ADD_BANK_ACCOUNT;
    case 2:
    case "DEPOSIT":
      return PaymentPurpose.DEPOSIT;
    case 3:
    case "REFUND":
      return PaymentPurpose.REFUND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PaymentPurpose.UNRECOGNIZED;
  }
}

export function paymentPurposeToJSON(object: PaymentPurpose): string {
  switch (object) {
    case PaymentPurpose.PAYMENT_PURPOSE_UNKNOWN:
      return "PAYMENT_PURPOSE_UNKNOWN";
    case PaymentPurpose.ADD_BANK_ACCOUNT:
      return "ADD_BANK_ACCOUNT";
    case PaymentPurpose.DEPOSIT:
      return "DEPOSIT";
    case PaymentPurpose.REFUND:
      return "REFUND";
    case PaymentPurpose.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PaymentStatus {
  PAYMENT_STATUS_UNKNOWN = 0,
  INITIATED = 1,
  SUCCESS = 2,
  FAILED = 3,
  PENDING = 4,
  REJECTED = 5,
  EXPIRED = 6,
  REFUND_INITIATED = 7,
  REFUNDED = 8,
  UNRECOGNIZED = -1,
}

export function paymentStatusFromJSON(object: any): PaymentStatus {
  switch (object) {
    case 0:
    case "PAYMENT_STATUS_UNKNOWN":
      return PaymentStatus.PAYMENT_STATUS_UNKNOWN;
    case 1:
    case "INITIATED":
      return PaymentStatus.INITIATED;
    case 2:
    case "SUCCESS":
      return PaymentStatus.SUCCESS;
    case 3:
    case "FAILED":
      return PaymentStatus.FAILED;
    case 4:
    case "PENDING":
      return PaymentStatus.PENDING;
    case 5:
    case "REJECTED":
      return PaymentStatus.REJECTED;
    case 6:
    case "EXPIRED":
      return PaymentStatus.EXPIRED;
    case 7:
    case "REFUND_INITIATED":
      return PaymentStatus.REFUND_INITIATED;
    case 8:
    case "REFUNDED":
      return PaymentStatus.REFUNDED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PaymentStatus.UNRECOGNIZED;
  }
}

export function paymentStatusToJSON(object: PaymentStatus): string {
  switch (object) {
    case PaymentStatus.PAYMENT_STATUS_UNKNOWN:
      return "PAYMENT_STATUS_UNKNOWN";
    case PaymentStatus.INITIATED:
      return "INITIATED";
    case PaymentStatus.SUCCESS:
      return "SUCCESS";
    case PaymentStatus.FAILED:
      return "FAILED";
    case PaymentStatus.PENDING:
      return "PENDING";
    case PaymentStatus.REJECTED:
      return "REJECTED";
    case PaymentStatus.EXPIRED:
      return "EXPIRED";
    case PaymentStatus.REFUND_INITIATED:
      return "REFUND_INITIATED";
    case PaymentStatus.REFUNDED:
      return "REFUNDED";
    case PaymentStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PaymentMethod {
  PAYMENT_METHOD_UNKNOWN = 0,
  UPI = 1,
  INTERNET_BANKING = 2,
  UNRECOGNIZED = -1,
}

export function paymentMethodFromJSON(object: any): PaymentMethod {
  switch (object) {
    case 0:
    case "PAYMENT_METHOD_UNKNOWN":
      return PaymentMethod.PAYMENT_METHOD_UNKNOWN;
    case 1:
    case "UPI":
      return PaymentMethod.UPI;
    case 2:
    case "INTERNET_BANKING":
      return PaymentMethod.INTERNET_BANKING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PaymentMethod.UNRECOGNIZED;
  }
}

export function paymentMethodToJSON(object: PaymentMethod): string {
  switch (object) {
    case PaymentMethod.PAYMENT_METHOD_UNKNOWN:
      return "PAYMENT_METHOD_UNKNOWN";
    case PaymentMethod.UPI:
      return "UPI";
    case PaymentMethod.INTERNET_BANKING:
      return "INTERNET_BANKING";
    case PaymentMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PaymentTransaction {
  id: string;
  dbId: number;
  provider: PaymentProvider;
  tradingAccountId: string;
  purpose: PaymentPurpose;
  amount: string;
  status: PaymentStatus;
  providerStatus: string;
  providerStatusDescription: string;
  upiTxnId: string;
  customerRefNumber: string;
  bankRefNumber: string;
  responseCode: string;
  payerVpa: string;
  payerName: string;
  payerBankName: string;
  payerAccountNumber: string;
  payerIfsc: string;
  payerAccountType: string;
  payerMobile: string;
  refundTransactionId: string;
  refundStatus: PaymentStatus;
  created: number;
  updated: number;
  /** Original payment transaction id for refund rows (purpose=REFUND). */
  referenceOrder: string;
  paymentMethod: PaymentMethod;
}

export interface InitiateBankAccountVerificationRequest {
  tradingAccountId: string;
}

export interface InitiateDepositRequest {
  tradingAccountId: string;
  amount: string;
  paymentMethod: PaymentMethod;
}

export interface UpiTransactionResponse {
  transactionId: string;
  upiIntentString: string;
  amount: string;
  status: PaymentStatus;
  provider: PaymentProvider;
}

export interface GetTransactionStatusRequest {
  transactionId: string;
}

export interface GetUpiIntentRequest {
  transactionId: string;
}

export interface ListPaymentTransactionsAdminRequest {
  /** epoch millis inclusive; 0 = no lower bound */
  from: number;
  /** epoch millis exclusive; 0 = no upper bound */
  to: number;
  /** PAYMENT_STATUS_UNKNOWN = all */
  status: PaymentStatus;
  page: number;
  pageSize: number;
}

export interface ListPaymentTransactionsAdminResponse {
  transactions: PaymentTransaction[];
  total: number;
}

export interface SimulateTransactionUpdateRequest {
  transactionId: string;
  /** SUCCESS | FAILED | REJECTED | EXPIRED */
  status: PaymentStatus;
  payerVpa: string;
  payerName: string;
  payerBankName: string;
  payerIfsc: string;
  payerAccountNumber: string;
  /** optional, default SAVINGS */
  payerAccountType: string;
}

function createBasePaymentTransaction(): PaymentTransaction {
  return {
    id: "",
    dbId: 0,
    provider: 0,
    tradingAccountId: "",
    purpose: 0,
    amount: "",
    status: 0,
    providerStatus: "",
    providerStatusDescription: "",
    upiTxnId: "",
    customerRefNumber: "",
    bankRefNumber: "",
    responseCode: "",
    payerVpa: "",
    payerName: "",
    payerBankName: "",
    payerAccountNumber: "",
    payerIfsc: "",
    payerAccountType: "",
    payerMobile: "",
    refundTransactionId: "",
    refundStatus: 0,
    created: 0,
    updated: 0,
    referenceOrder: "",
    paymentMethod: 0,
  };
}

export const PaymentTransaction = {
  encode(message: PaymentTransaction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.dbId !== 0) {
      writer.uint32(16).int64(message.dbId);
    }
    if (message.provider !== 0) {
      writer.uint32(24).int32(message.provider);
    }
    if (message.tradingAccountId !== "") {
      writer.uint32(34).string(message.tradingAccountId);
    }
    if (message.purpose !== 0) {
      writer.uint32(40).int32(message.purpose);
    }
    if (message.amount !== "") {
      writer.uint32(50).string(message.amount);
    }
    if (message.status !== 0) {
      writer.uint32(56).int32(message.status);
    }
    if (message.providerStatus !== "") {
      writer.uint32(66).string(message.providerStatus);
    }
    if (message.providerStatusDescription !== "") {
      writer.uint32(74).string(message.providerStatusDescription);
    }
    if (message.upiTxnId !== "") {
      writer.uint32(82).string(message.upiTxnId);
    }
    if (message.customerRefNumber !== "") {
      writer.uint32(90).string(message.customerRefNumber);
    }
    if (message.bankRefNumber !== "") {
      writer.uint32(98).string(message.bankRefNumber);
    }
    if (message.responseCode !== "") {
      writer.uint32(106).string(message.responseCode);
    }
    if (message.payerVpa !== "") {
      writer.uint32(114).string(message.payerVpa);
    }
    if (message.payerName !== "") {
      writer.uint32(122).string(message.payerName);
    }
    if (message.payerBankName !== "") {
      writer.uint32(130).string(message.payerBankName);
    }
    if (message.payerAccountNumber !== "") {
      writer.uint32(138).string(message.payerAccountNumber);
    }
    if (message.payerIfsc !== "") {
      writer.uint32(146).string(message.payerIfsc);
    }
    if (message.payerAccountType !== "") {
      writer.uint32(154).string(message.payerAccountType);
    }
    if (message.payerMobile !== "") {
      writer.uint32(162).string(message.payerMobile);
    }
    if (message.refundTransactionId !== "") {
      writer.uint32(170).string(message.refundTransactionId);
    }
    if (message.refundStatus !== 0) {
      writer.uint32(176).int32(message.refundStatus);
    }
    if (message.created !== 0) {
      writer.uint32(184).int64(message.created);
    }
    if (message.updated !== 0) {
      writer.uint32(192).int64(message.updated);
    }
    if (message.referenceOrder !== "") {
      writer.uint32(202).string(message.referenceOrder);
    }
    if (message.paymentMethod !== 0) {
      writer.uint32(208).int32(message.paymentMethod);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PaymentTransaction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaymentTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.dbId = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.purpose = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.providerStatus = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.providerStatusDescription = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.upiTxnId = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.customerRefNumber = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.bankRefNumber = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.responseCode = reader.string();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.payerVpa = reader.string();
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.payerName = reader.string();
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.payerBankName = reader.string();
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.payerAccountNumber = reader.string();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.payerIfsc = reader.string();
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.payerAccountType = reader.string();
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.payerMobile = reader.string();
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.refundTransactionId = reader.string();
          continue;
        case 22:
          if (tag !== 176) {
            break;
          }

          message.refundStatus = reader.int32() as any;
          continue;
        case 23:
          if (tag !== 184) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
        case 24:
          if (tag !== 192) {
            break;
          }

          message.updated = longToNumber(reader.int64() as Long);
          continue;
        case 25:
          if (tag !== 202) {
            break;
          }

          message.referenceOrder = reader.string();
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.paymentMethod = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaymentTransaction {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      dbId: isSet(object.dbId) ? globalThis.Number(object.dbId) : 0,
      provider: isSet(object.provider) ? paymentProviderFromJSON(object.provider) : 0,
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      purpose: isSet(object.purpose) ? paymentPurposeFromJSON(object.purpose) : 0,
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      status: isSet(object.status) ? paymentStatusFromJSON(object.status) : 0,
      providerStatus: isSet(object.providerStatus) ? globalThis.String(object.providerStatus) : "",
      providerStatusDescription: isSet(object.providerStatusDescription)
        ? globalThis.String(object.providerStatusDescription)
        : "",
      upiTxnId: isSet(object.upiTxnId) ? globalThis.String(object.upiTxnId) : "",
      customerRefNumber: isSet(object.customerRefNumber) ? globalThis.String(object.customerRefNumber) : "",
      bankRefNumber: isSet(object.bankRefNumber) ? globalThis.String(object.bankRefNumber) : "",
      responseCode: isSet(object.responseCode) ? globalThis.String(object.responseCode) : "",
      payerVpa: isSet(object.payerVpa) ? globalThis.String(object.payerVpa) : "",
      payerName: isSet(object.payerName) ? globalThis.String(object.payerName) : "",
      payerBankName: isSet(object.payerBankName) ? globalThis.String(object.payerBankName) : "",
      payerAccountNumber: isSet(object.payerAccountNumber) ? globalThis.String(object.payerAccountNumber) : "",
      payerIfsc: isSet(object.payerIfsc) ? globalThis.String(object.payerIfsc) : "",
      payerAccountType: isSet(object.payerAccountType) ? globalThis.String(object.payerAccountType) : "",
      payerMobile: isSet(object.payerMobile) ? globalThis.String(object.payerMobile) : "",
      refundTransactionId: isSet(object.refundTransactionId) ? globalThis.String(object.refundTransactionId) : "",
      refundStatus: isSet(object.refundStatus) ? paymentStatusFromJSON(object.refundStatus) : 0,
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      updated: isSet(object.updated) ? globalThis.Number(object.updated) : 0,
      referenceOrder: isSet(object.referenceOrder) ? globalThis.String(object.referenceOrder) : "",
      paymentMethod: isSet(object.paymentMethod) ? paymentMethodFromJSON(object.paymentMethod) : 0,
    };
  },

  toJSON(message: PaymentTransaction): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.dbId !== 0) {
      obj.dbId = Math.round(message.dbId);
    }
    if (message.provider !== 0) {
      obj.provider = paymentProviderToJSON(message.provider);
    }
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.purpose !== 0) {
      obj.purpose = paymentPurposeToJSON(message.purpose);
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.status !== 0) {
      obj.status = paymentStatusToJSON(message.status);
    }
    if (message.providerStatus !== "") {
      obj.providerStatus = message.providerStatus;
    }
    if (message.providerStatusDescription !== "") {
      obj.providerStatusDescription = message.providerStatusDescription;
    }
    if (message.upiTxnId !== "") {
      obj.upiTxnId = message.upiTxnId;
    }
    if (message.customerRefNumber !== "") {
      obj.customerRefNumber = message.customerRefNumber;
    }
    if (message.bankRefNumber !== "") {
      obj.bankRefNumber = message.bankRefNumber;
    }
    if (message.responseCode !== "") {
      obj.responseCode = message.responseCode;
    }
    if (message.payerVpa !== "") {
      obj.payerVpa = message.payerVpa;
    }
    if (message.payerName !== "") {
      obj.payerName = message.payerName;
    }
    if (message.payerBankName !== "") {
      obj.payerBankName = message.payerBankName;
    }
    if (message.payerAccountNumber !== "") {
      obj.payerAccountNumber = message.payerAccountNumber;
    }
    if (message.payerIfsc !== "") {
      obj.payerIfsc = message.payerIfsc;
    }
    if (message.payerAccountType !== "") {
      obj.payerAccountType = message.payerAccountType;
    }
    if (message.payerMobile !== "") {
      obj.payerMobile = message.payerMobile;
    }
    if (message.refundTransactionId !== "") {
      obj.refundTransactionId = message.refundTransactionId;
    }
    if (message.refundStatus !== 0) {
      obj.refundStatus = paymentStatusToJSON(message.refundStatus);
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.updated !== 0) {
      obj.updated = Math.round(message.updated);
    }
    if (message.referenceOrder !== "") {
      obj.referenceOrder = message.referenceOrder;
    }
    if (message.paymentMethod !== 0) {
      obj.paymentMethod = paymentMethodToJSON(message.paymentMethod);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentTransaction>, I>>(base?: I): PaymentTransaction {
    return PaymentTransaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaymentTransaction>, I>>(object: I): PaymentTransaction {
    const message = createBasePaymentTransaction();
    message.id = object.id ?? "";
    message.dbId = object.dbId ?? 0;
    message.provider = object.provider ?? 0;
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.purpose = object.purpose ?? 0;
    message.amount = object.amount ?? "";
    message.status = object.status ?? 0;
    message.providerStatus = object.providerStatus ?? "";
    message.providerStatusDescription = object.providerStatusDescription ?? "";
    message.upiTxnId = object.upiTxnId ?? "";
    message.customerRefNumber = object.customerRefNumber ?? "";
    message.bankRefNumber = object.bankRefNumber ?? "";
    message.responseCode = object.responseCode ?? "";
    message.payerVpa = object.payerVpa ?? "";
    message.payerName = object.payerName ?? "";
    message.payerBankName = object.payerBankName ?? "";
    message.payerAccountNumber = object.payerAccountNumber ?? "";
    message.payerIfsc = object.payerIfsc ?? "";
    message.payerAccountType = object.payerAccountType ?? "";
    message.payerMobile = object.payerMobile ?? "";
    message.refundTransactionId = object.refundTransactionId ?? "";
    message.refundStatus = object.refundStatus ?? 0;
    message.created = object.created ?? 0;
    message.updated = object.updated ?? 0;
    message.referenceOrder = object.referenceOrder ?? "";
    message.paymentMethod = object.paymentMethod ?? 0;
    return message;
  },
};

function createBaseInitiateBankAccountVerificationRequest(): InitiateBankAccountVerificationRequest {
  return { tradingAccountId: "" };
}

export const InitiateBankAccountVerificationRequest = {
  encode(message: InitiateBankAccountVerificationRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitiateBankAccountVerificationRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitiateBankAccountVerificationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitiateBankAccountVerificationRequest {
    return { tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "" };
  },

  toJSON(message: InitiateBankAccountVerificationRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitiateBankAccountVerificationRequest>, I>>(
    base?: I,
  ): InitiateBankAccountVerificationRequest {
    return InitiateBankAccountVerificationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitiateBankAccountVerificationRequest>, I>>(
    object: I,
  ): InitiateBankAccountVerificationRequest {
    const message = createBaseInitiateBankAccountVerificationRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    return message;
  },
};

function createBaseInitiateDepositRequest(): InitiateDepositRequest {
  return { tradingAccountId: "", amount: "", paymentMethod: 0 };
}

export const InitiateDepositRequest = {
  encode(message: InitiateDepositRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.tradingAccountId !== "") {
      writer.uint32(10).string(message.tradingAccountId);
    }
    if (message.amount !== "") {
      writer.uint32(18).string(message.amount);
    }
    if (message.paymentMethod !== 0) {
      writer.uint32(24).int32(message.paymentMethod);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitiateDepositRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitiateDepositRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.paymentMethod = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitiateDepositRequest {
    return {
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      paymentMethod: isSet(object.paymentMethod) ? paymentMethodFromJSON(object.paymentMethod) : 0,
    };
  },

  toJSON(message: InitiateDepositRequest): unknown {
    const obj: any = {};
    if (message.tradingAccountId !== "") {
      obj.tradingAccountId = message.tradingAccountId;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.paymentMethod !== 0) {
      obj.paymentMethod = paymentMethodToJSON(message.paymentMethod);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitiateDepositRequest>, I>>(base?: I): InitiateDepositRequest {
    return InitiateDepositRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitiateDepositRequest>, I>>(object: I): InitiateDepositRequest {
    const message = createBaseInitiateDepositRequest();
    message.tradingAccountId = object.tradingAccountId ?? "";
    message.amount = object.amount ?? "";
    message.paymentMethod = object.paymentMethod ?? 0;
    return message;
  },
};

function createBaseUpiTransactionResponse(): UpiTransactionResponse {
  return { transactionId: "", upiIntentString: "", amount: "", status: 0, provider: 0 };
}

export const UpiTransactionResponse = {
  encode(message: UpiTransactionResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transactionId !== "") {
      writer.uint32(10).string(message.transactionId);
    }
    if (message.upiIntentString !== "") {
      writer.uint32(18).string(message.upiIntentString);
    }
    if (message.amount !== "") {
      writer.uint32(26).string(message.amount);
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    if (message.provider !== 0) {
      writer.uint32(40).int32(message.provider);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpiTransactionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpiTransactionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transactionId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.upiIntentString = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.amount = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpiTransactionResponse {
    return {
      transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : "",
      upiIntentString: isSet(object.upiIntentString) ? globalThis.String(object.upiIntentString) : "",
      amount: isSet(object.amount) ? globalThis.String(object.amount) : "",
      status: isSet(object.status) ? paymentStatusFromJSON(object.status) : 0,
      provider: isSet(object.provider) ? paymentProviderFromJSON(object.provider) : 0,
    };
  },

  toJSON(message: UpiTransactionResponse): unknown {
    const obj: any = {};
    if (message.transactionId !== "") {
      obj.transactionId = message.transactionId;
    }
    if (message.upiIntentString !== "") {
      obj.upiIntentString = message.upiIntentString;
    }
    if (message.amount !== "") {
      obj.amount = message.amount;
    }
    if (message.status !== 0) {
      obj.status = paymentStatusToJSON(message.status);
    }
    if (message.provider !== 0) {
      obj.provider = paymentProviderToJSON(message.provider);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpiTransactionResponse>, I>>(base?: I): UpiTransactionResponse {
    return UpiTransactionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpiTransactionResponse>, I>>(object: I): UpiTransactionResponse {
    const message = createBaseUpiTransactionResponse();
    message.transactionId = object.transactionId ?? "";
    message.upiIntentString = object.upiIntentString ?? "";
    message.amount = object.amount ?? "";
    message.status = object.status ?? 0;
    message.provider = object.provider ?? 0;
    return message;
  },
};

function createBaseGetTransactionStatusRequest(): GetTransactionStatusRequest {
  return { transactionId: "" };
}

export const GetTransactionStatusRequest = {
  encode(message: GetTransactionStatusRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transactionId !== "") {
      writer.uint32(10).string(message.transactionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTransactionStatusRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTransactionStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transactionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTransactionStatusRequest {
    return { transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : "" };
  },

  toJSON(message: GetTransactionStatusRequest): unknown {
    const obj: any = {};
    if (message.transactionId !== "") {
      obj.transactionId = message.transactionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTransactionStatusRequest>, I>>(base?: I): GetTransactionStatusRequest {
    return GetTransactionStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTransactionStatusRequest>, I>>(object: I): GetTransactionStatusRequest {
    const message = createBaseGetTransactionStatusRequest();
    message.transactionId = object.transactionId ?? "";
    return message;
  },
};

function createBaseGetUpiIntentRequest(): GetUpiIntentRequest {
  return { transactionId: "" };
}

export const GetUpiIntentRequest = {
  encode(message: GetUpiIntentRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transactionId !== "") {
      writer.uint32(10).string(message.transactionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetUpiIntentRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUpiIntentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transactionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUpiIntentRequest {
    return { transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : "" };
  },

  toJSON(message: GetUpiIntentRequest): unknown {
    const obj: any = {};
    if (message.transactionId !== "") {
      obj.transactionId = message.transactionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUpiIntentRequest>, I>>(base?: I): GetUpiIntentRequest {
    return GetUpiIntentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUpiIntentRequest>, I>>(object: I): GetUpiIntentRequest {
    const message = createBaseGetUpiIntentRequest();
    message.transactionId = object.transactionId ?? "";
    return message;
  },
};

function createBaseListPaymentTransactionsAdminRequest(): ListPaymentTransactionsAdminRequest {
  return { from: 0, to: 0, status: 0, page: 0, pageSize: 0 };
}

export const ListPaymentTransactionsAdminRequest = {
  encode(message: ListPaymentTransactionsAdminRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.from !== 0) {
      writer.uint32(8).int64(message.from);
    }
    if (message.to !== 0) {
      writer.uint32(16).int64(message.to);
    }
    if (message.status !== 0) {
      writer.uint32(24).int32(message.status);
    }
    if (message.page !== 0) {
      writer.uint32(32).int32(message.page);
    }
    if (message.pageSize !== 0) {
      writer.uint32(40).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListPaymentTransactionsAdminRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPaymentTransactionsAdminRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.from = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.to = longToNumber(reader.int64() as Long);
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.page = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPaymentTransactionsAdminRequest {
    return {
      from: isSet(object.from) ? globalThis.Number(object.from) : 0,
      to: isSet(object.to) ? globalThis.Number(object.to) : 0,
      status: isSet(object.status) ? paymentStatusFromJSON(object.status) : 0,
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
    };
  },

  toJSON(message: ListPaymentTransactionsAdminRequest): unknown {
    const obj: any = {};
    if (message.from !== 0) {
      obj.from = Math.round(message.from);
    }
    if (message.to !== 0) {
      obj.to = Math.round(message.to);
    }
    if (message.status !== 0) {
      obj.status = paymentStatusToJSON(message.status);
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPaymentTransactionsAdminRequest>, I>>(
    base?: I,
  ): ListPaymentTransactionsAdminRequest {
    return ListPaymentTransactionsAdminRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPaymentTransactionsAdminRequest>, I>>(
    object: I,
  ): ListPaymentTransactionsAdminRequest {
    const message = createBaseListPaymentTransactionsAdminRequest();
    message.from = object.from ?? 0;
    message.to = object.to ?? 0;
    message.status = object.status ?? 0;
    message.page = object.page ?? 0;
    message.pageSize = object.pageSize ?? 0;
    return message;
  },
};

function createBaseListPaymentTransactionsAdminResponse(): ListPaymentTransactionsAdminResponse {
  return { transactions: [], total: 0 };
}

export const ListPaymentTransactionsAdminResponse = {
  encode(message: ListPaymentTransactionsAdminResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.transactions) {
      PaymentTransaction.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.total !== 0) {
      writer.uint32(16).int32(message.total);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListPaymentTransactionsAdminResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPaymentTransactionsAdminResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transactions.push(PaymentTransaction.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.total = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPaymentTransactionsAdminResponse {
    return {
      transactions: globalThis.Array.isArray(object?.transactions)
        ? object.transactions.map((e: any) => PaymentTransaction.fromJSON(e))
        : [],
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
    };
  },

  toJSON(message: ListPaymentTransactionsAdminResponse): unknown {
    const obj: any = {};
    if (message.transactions?.length) {
      obj.transactions = message.transactions.map((e) => PaymentTransaction.toJSON(e));
    }
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPaymentTransactionsAdminResponse>, I>>(
    base?: I,
  ): ListPaymentTransactionsAdminResponse {
    return ListPaymentTransactionsAdminResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPaymentTransactionsAdminResponse>, I>>(
    object: I,
  ): ListPaymentTransactionsAdminResponse {
    const message = createBaseListPaymentTransactionsAdminResponse();
    message.transactions = object.transactions?.map((e) => PaymentTransaction.fromPartial(e)) || [];
    message.total = object.total ?? 0;
    return message;
  },
};

function createBaseSimulateTransactionUpdateRequest(): SimulateTransactionUpdateRequest {
  return {
    transactionId: "",
    status: 0,
    payerVpa: "",
    payerName: "",
    payerBankName: "",
    payerIfsc: "",
    payerAccountNumber: "",
    payerAccountType: "",
  };
}

export const SimulateTransactionUpdateRequest = {
  encode(message: SimulateTransactionUpdateRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transactionId !== "") {
      writer.uint32(10).string(message.transactionId);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.payerVpa !== "") {
      writer.uint32(26).string(message.payerVpa);
    }
    if (message.payerName !== "") {
      writer.uint32(34).string(message.payerName);
    }
    if (message.payerBankName !== "") {
      writer.uint32(42).string(message.payerBankName);
    }
    if (message.payerIfsc !== "") {
      writer.uint32(50).string(message.payerIfsc);
    }
    if (message.payerAccountNumber !== "") {
      writer.uint32(58).string(message.payerAccountNumber);
    }
    if (message.payerAccountType !== "") {
      writer.uint32(66).string(message.payerAccountType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimulateTransactionUpdateRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimulateTransactionUpdateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.transactionId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.payerVpa = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.payerName = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.payerBankName = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.payerIfsc = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.payerAccountNumber = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.payerAccountType = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimulateTransactionUpdateRequest {
    return {
      transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : "",
      status: isSet(object.status) ? paymentStatusFromJSON(object.status) : 0,
      payerVpa: isSet(object.payerVpa) ? globalThis.String(object.payerVpa) : "",
      payerName: isSet(object.payerName) ? globalThis.String(object.payerName) : "",
      payerBankName: isSet(object.payerBankName) ? globalThis.String(object.payerBankName) : "",
      payerIfsc: isSet(object.payerIfsc) ? globalThis.String(object.payerIfsc) : "",
      payerAccountNumber: isSet(object.payerAccountNumber) ? globalThis.String(object.payerAccountNumber) : "",
      payerAccountType: isSet(object.payerAccountType) ? globalThis.String(object.payerAccountType) : "",
    };
  },

  toJSON(message: SimulateTransactionUpdateRequest): unknown {
    const obj: any = {};
    if (message.transactionId !== "") {
      obj.transactionId = message.transactionId;
    }
    if (message.status !== 0) {
      obj.status = paymentStatusToJSON(message.status);
    }
    if (message.payerVpa !== "") {
      obj.payerVpa = message.payerVpa;
    }
    if (message.payerName !== "") {
      obj.payerName = message.payerName;
    }
    if (message.payerBankName !== "") {
      obj.payerBankName = message.payerBankName;
    }
    if (message.payerIfsc !== "") {
      obj.payerIfsc = message.payerIfsc;
    }
    if (message.payerAccountNumber !== "") {
      obj.payerAccountNumber = message.payerAccountNumber;
    }
    if (message.payerAccountType !== "") {
      obj.payerAccountType = message.payerAccountType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimulateTransactionUpdateRequest>, I>>(
    base?: I,
  ): SimulateTransactionUpdateRequest {
    return SimulateTransactionUpdateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimulateTransactionUpdateRequest>, I>>(
    object: I,
  ): SimulateTransactionUpdateRequest {
    const message = createBaseSimulateTransactionUpdateRequest();
    message.transactionId = object.transactionId ?? "";
    message.status = object.status ?? 0;
    message.payerVpa = object.payerVpa ?? "";
    message.payerName = object.payerName ?? "";
    message.payerBankName = object.payerBankName ?? "";
    message.payerIfsc = object.payerIfsc ?? "";
    message.payerAccountNumber = object.payerAccountNumber ?? "";
    message.payerAccountType = object.payerAccountType ?? "";
    return message;
  },
};

export interface PaymentsService {
  InitiateBankAccountVerification(request: InitiateBankAccountVerificationRequest): Promise<UpiTransactionResponse>;
  InitiateDeposit(request: InitiateDepositRequest): Promise<UpiTransactionResponse>;
  GetTransactionStatus(request: GetTransactionStatusRequest): Promise<PaymentTransaction>;
  /** Rebuilds the UPI intent string from the stored transaction id/amount + current provider config. */
  GetUpiIntent(request: GetUpiIntentRequest): Promise<UpiTransactionResponse>;
  ListTransactionsAdmin(request: ListPaymentTransactionsAdminRequest): Promise<ListPaymentTransactionsAdminResponse>;
  SimulateTransactionUpdate(request: SimulateTransactionUpdateRequest): Promise<PaymentTransaction>;
}

export const PaymentsServiceServiceName = "com.tick2trade.api.payments.PaymentsService";
export class PaymentsServiceClientImpl implements PaymentsService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || PaymentsServiceServiceName;
    this.rpc = rpc;
    this.InitiateBankAccountVerification = this.InitiateBankAccountVerification.bind(this);
    this.InitiateDeposit = this.InitiateDeposit.bind(this);
    this.GetTransactionStatus = this.GetTransactionStatus.bind(this);
    this.GetUpiIntent = this.GetUpiIntent.bind(this);
    this.ListTransactionsAdmin = this.ListTransactionsAdmin.bind(this);
    this.SimulateTransactionUpdate = this.SimulateTransactionUpdate.bind(this);
  }
  InitiateBankAccountVerification(request: InitiateBankAccountVerificationRequest): Promise<UpiTransactionResponse> {
    const data = InitiateBankAccountVerificationRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "InitiateBankAccountVerification", data);
    return promise.then((data) => UpiTransactionResponse.decode(_m0.Reader.create(data)));
  }

  InitiateDeposit(request: InitiateDepositRequest): Promise<UpiTransactionResponse> {
    const data = InitiateDepositRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "InitiateDeposit", data);
    return promise.then((data) => UpiTransactionResponse.decode(_m0.Reader.create(data)));
  }

  GetTransactionStatus(request: GetTransactionStatusRequest): Promise<PaymentTransaction> {
    const data = GetTransactionStatusRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTransactionStatus", data);
    return promise.then((data) => PaymentTransaction.decode(_m0.Reader.create(data)));
  }

  GetUpiIntent(request: GetUpiIntentRequest): Promise<UpiTransactionResponse> {
    const data = GetUpiIntentRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetUpiIntent", data);
    return promise.then((data) => UpiTransactionResponse.decode(_m0.Reader.create(data)));
  }

  ListTransactionsAdmin(request: ListPaymentTransactionsAdminRequest): Promise<ListPaymentTransactionsAdminResponse> {
    const data = ListPaymentTransactionsAdminRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "ListTransactionsAdmin", data);
    return promise.then((data) => ListPaymentTransactionsAdminResponse.decode(_m0.Reader.create(data)));
  }

  SimulateTransactionUpdate(request: SimulateTransactionUpdateRequest): Promise<PaymentTransaction> {
    const data = SimulateTransactionUpdateRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "SimulateTransactionUpdate", data);
    return promise.then((data) => PaymentTransaction.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
